import { prettyNumber, todayLine } from './api';
import { soulSummary } from './soul';

/**
 * The front desk at a glance, for the card on the Bailey home: whether
 * Bailey is answering, where, in which soul, and what's set up. Pure, so the
 * card and its tests read the same words.
 */
export function glanceFor({ settings, answers, counts, soul, onCall = false, hasConversations = false }) {
    const s = settings || {};
    const on = !!(s.enabled || s.voiceEnabled);
    const title = !on ? 'Not answering clients'
        : s.enabled && s.voiceEnabled ? 'Answering chat and calls'
            : s.enabled ? 'Answering on your booking page'
                : 'Answering your phone';
    const said = soulSummary(soul);
    const sub = onCall ? 'On a call now'
        : on ? `${said} · ${hasConversations ? todayLine(counts || {}) : 'Ready for your clients'}`
            : `${said} · Switch on chat or the phone to start`;
    const n = (answers || []).length;
    return {
        on,
        state: onCall ? 'On a call' : on ? 'Live' : 'Off',
        title,
        sub,
        cells: [
            { key: 'chat', label: 'Chat', value: s.enabled ? 'On' : 'Off' },
            { key: 'phone', label: 'Phone', value: s.voiceNumber ? (s.voiceEnabled ? prettyNumber(s.voiceNumber) : 'Off') : 'Not set up' },
            { key: 'know', label: 'What I know', value: n ? `${n} ${n === 1 ? 'answer' : 'answers'}` : 'None added' }
        ]
    };
}

/** "Live" and where, for the section heading beside the switches. */
export function answeringLabel(settings, onCall = false) {
    const s = settings || {};
    if (onCall) return 'On a call';
    if (s.enabled && s.voiceEnabled) return 'Live on chat and phone';
    if (s.enabled) return 'Live on chat';
    if (s.voiceEnabled) return 'Live on the phone';
    return 'Off';
}
